export enum TreeTypeEnum {
    Locations ="Locations",
    Categories = "Categories",
    Favorites = "Favorites"
}